﻿<forge-expansion-panel *ngFor="let group of groups | orderBy:'Group'" [open]="group.Open" (forge-expansion-panel-toggle)="toggle($event, group)">
    <forge-list-item slot="header" class="card-list--border-bottom">
        <button type="button" class="card-list--expand-button-{{depth}} forge-typography--heading2">{{group.Group}} ({{group.Count}})</button>
        <forge-open-icon slot="end"></forge-open-icon>
    </forge-list-item>
    <div>
        <forge-list *ngIf="group.Open">
            <ng-container *ngTemplateOutlet="group.Entities ? entityCards : subGroup; context: { $implicit: group }">
            </ng-container>
        </forge-list>
    </div>
</forge-expansion-panel>

<ng-template #subGroup let-group>
    <card-list-group [depth]="depth + 1" [view]="view" [groups]="group.Groups" [datacontroller]="datacontroller" [hasBody]="hasBody"></card-list-group>
</ng-template>

<ng-template #entityCards let-group>
    <forge-card *ngFor="let model of group.Entities">
        <forge-expansion-panel class="card-list-item-header">
            <card-list-item-header slot="header" [cardMetadata]="view.Card" [model]="model" [datacontroller]="datacontroller" [hasBody]="hasBody"></card-list-item-header>
            <card-list-item-body *ngIf="hasBody" [cardMetadata]="view.Card" [dense]="view.Dense" [model]="model"></card-list-item-body>
        </forge-expansion-panel>
    </forge-card>
</ng-template>
